<template>
  <div class="map" id="map">
    <div
      id="map1"
      style="width: 100%; height: 100%; overflow: hidden; margin: 0"
    ></div>
    <div id="searchID" class="constructionsearch">
      <el-select
        clearable
        style="width: 250px"
        v-model="construction"
        @change="constructionchange"
        filterable
        placeholder="请选择"
      >
        <el-option
          v-for="item in constructiondata"
          :key="item.name"
          :label="item.name"
          :value="item"
        ></el-option>
      </el-select>
      <el-button slot="append" icon="el-icon-search"></el-button>
    </div>
    <div class="listbtnbox">
      <div class="listbtn" @click="sectionon">部门列表</div>
      <div class="listbtn" @click="propertyon">工地属性</div>
      <div class="listbtn" @click="areaon">所属区域</div>
      <div class="listbtn" @click="scurvinesson">恶劣工地</div>
    </div>
    <div class="sectionbox" v-if="sectionflag">
      <div class="title">部门列表</div>
      <div class="close" @click="onclear">
        <i class="el-icon-close" />
      </div>
      <div class="wire"></div>
      <div class="search">
        <el-input
          placeholder="请输入内容"
          @input="domainchange"
          :value="screening"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="checks">
        <el-checkbox-group
          v-model="checkdata"
          @change="handleCheckedCitiesChange"
        >
          <div class="checklist" v-for="item in domainName" :key="item.index">
            <el-checkbox :label="item.label">{{ item.label }}</el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <div class="regionbtn">
        <el-button
          size="small"
          @click="regionclick"
          style="width: 200px"
          type="primary"
          >确定</el-button
        >
      </div>
    </div>

    <div class="sectionbox" v-if="propertyflag">
      <div class="title">工地属性</div>
      <div class="close" @click="propertyflag = false">
        <i class="el-icon-close" />
      </div>
      <div class="wire"></div>
      <div class="checks" style="height: 370px">
        <el-checkbox-group v-model="propertydata" @change="propertyChange">
          <div class="checklist">
            <el-checkbox label="一类民生">一类民生</el-checkbox>
          </div>
          <div class="checklist">
            <el-checkbox label="二类民生">二类民生</el-checkbox>
          </div>
          <div class="checklist">
            <el-checkbox label="三类民生">三类民生</el-checkbox>
          </div>
          <div class="checklist">
            <el-checkbox label="绿牌">绿牌</el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <div class="regionbtn">
        <el-button
          size="small"
          @click="propertyclick"
          style="width: 200px"
          type="primary"
          >确定</el-button
        >
      </div>
    </div>

    <div class="sectionbox" v-if="areaflag">
      <div class="title">所属区域</div>
      <div class="close" @click="areaflag = false">
        <i class="el-icon-close" />
      </div>
      <div class="wire"></div>
      <div class="checks" style="height: 370px">
        <el-checkbox-group v-model="areadata" @change="areaChange">
          <div class="checklist">
            <el-checkbox label="A">A</el-checkbox>
          </div>
          <div class="checklist">
            <el-checkbox label="B">B</el-checkbox>
          </div>
          <div class="checklist">
            <el-checkbox label="C">C</el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <div class="regionbtn">
        <el-button
          size="small"
          @click="areaclick"
          style="width: 200px"
          type="primary"
          >确定</el-button
        >
      </div>
    </div>

    <div class="sectionbox" v-if="scurvinessflag">
      <div class="title">恶劣工地</div>
      <div class="close" @click="scurvinessflag = false">
        <i class="el-icon-close" />
      </div>
      <div class="wire"></div>
      <div class="checks" style="height: 370px">
        <el-checkbox-group v-model="scurvinessdata" @change="scurvinessChange">
          <div class="checklist">
            <el-checkbox label="have">有恶劣工地</el-checkbox>
          </div>
          <div class="checklist">
            <el-checkbox label="nothave">无恶劣工地</el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <div class="regionbtn">
        <el-button
          size="small"
          @click="scurvinessclick"
          style="width: 200px"
          type="primary"
          >确定</el-button
        >
      </div>
    </div>

    <div class="timeblock">
      <el-radio-group
        @change="timetypechange"
        style="margin-right: 20px"
        v-model="timetype"
        size="small"
      >
        <el-radio-button @click.native="clicktimechange($event, 3)" label="3"
          >三天</el-radio-button
        >
        <el-radio-button @click.native="clicktimechange($event, 7)" label="7"
          >七天</el-radio-button
        >
      </el-radio-group>
      <el-date-picker
        v-model="dateValue"
        type="daterange"
        size="small"
        @change="timechange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      ></el-date-picker>
    </div>
    <div class="mapblock">
      <div class="block1">
        <p
          class="block3 mb16"
          :class="{ addcolor: type1.includes(item.type) }"
          v-for="(item, index) in list1"
          :key="index"
          @click="blockclick1(item.type)"
        >
          <span :class="['iconfont', item.icon].join(' ')"></span>
          <span>{{ item.name }}</span>
        </p>
      </div>
      <div class="block4">
        <p
          class="item bb"
          :class="{ addcolor: type2 === item.type }"
          v-for="(item, index) in list2"
          :key="index"
          @click="blockclick2(item.type)"
        >
          {{ item.name }}
        </p>
      </div>
    </div>
    <div class="prompt">
      注：
      <img src="../assets/img/property_1.png" alt />
      <span>一类民生</span>
      <img src="../assets/img/property_2.png" alt />
      <span>二类民生</span>
      <img src="../assets/img/property_3.png" alt />
      <span>三类民生</span>
      <img src="../assets/img/property_4.png" alt />
      <span>绿牌</span>
      <img src="../assets/img/property_5.png" alt />
      <span>无</span>
      <img src="../assets/img/scurviness_icon.png" alt />
      <span>恶劣工地</span>
    </div>
  </div>
</template>

<script>
// import Rectify1 from "../assets/img/rectify1.png";
// import Rectify2 from "../assets/img/rectify2.png";
import Property_1 from "../assets/img/property_1.png";
import Property_2 from "../assets/img/property_2.png";
import Property_3 from "../assets/img/property_3.png";
import Property_4 from "../assets/img/property_4.png";
import Property_5 from "../assets/img/property_5.png";
import RectifyIcon from "../assets/img/rectifyicon.png";
import DeductIcon from "../assets/img/deducticon.png";
import PunishIcon from "../assets/img/punishicon.png";
import ScurvinessIcon from "../assets/img/scurviness_icon.png";

import BDStyle from "@/style/style";
import DivideData1 from "./dividedata1";
import { APIMAP } from "@/constants/apiConstants";
import { getServerData } from "@/utils/fetchData";
import { getFormatDate, getFormatDateAdd } from "@/utils/util";
import { mapState } from "vuex";
var BMap = window.BMap;
// var BMapLib = window.BMapLib;
export default {
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    // const endtime = getFormatDate().substring(0, 10);
    // const starttime = getFormatDateAdd(endtime, -3).substring(0, 10);
    return {
      data: [],
      level: 13,
      LocalCityName: "",
      construction: "",
      constructiondata: [],
      list1: [
        {
          name: "整改",
          type: "rectify",
          icon: "icon-jianshezhenggai",
        },
        {
          name: "扣分",
          type: "deduction",
          icon: "icon-koufenjilu",
        },
        {
          name: "处罚",
          type: "punishment",
          icon: "icon-chufaxitong",
        },
      ],
      list2: [
        { name: "全部", type: "all" },
        { name: "流转中", type: "circulation" },
        { name: "已完成", type: "done" },
      ],
      type1: [],
      type2: "all",
      alltype: ["rectify", "deduction", "punishment"],
      map: "",
      sectionflag: false,
      propertyflag: false,
      areaflag: false,
      scurvinessflag: false,
      checkdata: [],
      checkname: [],
      propertydata: [],
      areadata: [],
      scurvinessdata: [],
      domainName: DivideData1.domainName,
      allname: DivideData1.domainName,
      screening: "",
      timetype: "",
      // starttime: starttime,
      // endtime: endtime,
      // dateValue: [this.formatting(starttime), this.formatting(endtime)],
      starttime: "",
      endtime: "",
      dateValue: [],
      mapData: [],
      data1: [],
      data2: [],
    };
  },
  mounted() {
    this.initMap();
    this.getSiteData();
    this.getMapData();
  },
  methods: {
    //初始化地图并且获取城市定位
    // currentLocation() {
    //   var map = new window.BMap.Map("map1"); // 创建地图实例
    //   map.setMapStyle({ styleJson: BDStyle });
    //   // this.map = map;
    //   if (!this.LocalCityName) {
    //     const BMap = window.BMap;
    //     var myCity = new BMap.LocalCity();
    //     myCity.get(result => {
    //       var cityName = result.name;
    //       map.setCenter(cityName);
    //       // console.log("当前城市", cityName);
    //       this.LocalCityName = cityName;
    //       map.centerAndZoom(this.LocalCityName, 12);
    //       map.enableScrollWheelZoom(true);
    //     });
    //   }
    //   this.map = map;
    //   this.getBoundary();
    // },
    formatting(time) {
      const date = new Date(time).getTime();
      console.log(date);
      return date;
    },
    initMap() {
      var map = new BMap.Map("map1"); // 创建Map实例
      console.log(1234);
      map.setMapStyle({ styleJson: BDStyle });
      map.centerAndZoom("金水区", 13); // 初始化地图,设置中心点坐标和地图级别
      map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
      map.addEventListener("click", function (e) {
        console.log(e, "点击的经纬度：" + e.point.lng + ", " + e.point.lat);
      });
      this.map = map;
      this.getBoundary();
    },
    clearPois() {
      this.map.getOverlays().forEach((marker) => {
        if (marker.type === "pois") {
          this.map.removeOverlay(marker);
        }
      });
    },
    getBoundary() {
      console.log(DivideData1);
      this.clearPois();
      var regionname = [
        "银行学校环境改善区",
        "郑纺机环境改善区",
        "杨金、兴达城乡结合部",
        "丰产、未来、凤凰台",
      ];
      var regionpoint = [
        ["113.66892921153593", "34.838336493114845"],
        ["113.66346751403526", "34.789495963263015"],
        ["113.78362485904991", "34.85634795053287"],
        ["113.71607228469956", "34.76933480451231"],
      ];

      var pois = [];
      // DivideData.laldata.forEach((item, i) => {
      //   pois.push([]);
      //   console.log(this.checkdata.indexOf(i) > -1);
      //   if (this.checkdata.indexOf(i) > -1 || this.checkdata.length == 0) {
      //     item.forEach(obj => {
      //       pois[i].push(new BMap.Point(obj[0], obj[1]));
      //     });
      //   }
      // });
      const sy = new BMap.Symbol("BMap_Symbol_SHAPE_BACKWARD_OPEN_ARROW", {
        scale: 0.4,
        strokeColor: "#fff",
        strokeWeight: "1",
      });
      const icons = new BMap.IconSequence(sy, "10", "30");

      DivideData1.domainName.forEach((item, i) => {
        pois.push([]);
        if (
          this.checkdata.indexOf(item.label) > -1 ||
          this.checkdata.length == 0
        ) {
          DivideData1.laldata[item.label].forEach((obj) => {
            pois[i].push(new BMap.Point(obj[0], obj[1]));
          });
        }
      });
      pois.forEach((item) => {
        var polyline = new BMap.Polygon(item, {
          enableEditing: false,
          enableClicking: true,
          icons: [icons],
          strokeWeight: 2,
          // strokeColor: "#f00",
          strokeColor: "red",
          fillColor: "rgba(0, 0, 0, 0)",
          strokeStyle: "dashed",
        });
        polyline.type = "pois";
        this.map.addOverlay(polyline);
      });

      var regiondata = [];
      DivideData1.regionpoint.forEach((item, i) => {
        console.log("......", item);
        const name = regionname[i];
        const point = new BMap.Point(regionpoint[i][0], regionpoint[i][1]);
        const tipopts = {
          position: point,
          offset: new BMap.Size(-name.length * 7 - 4, 18),
        };
        const tiplabel = new BMap.Label(name, tipopts);
        tiplabel.setStyle({
          color: "#000",
          border: "none",
          fontSize: "14px",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          padding: "0 4px",
          borderRadius: "2px",
        });
        tiplabel.type = "pois";
        tiplabel.setZIndex(100);
        this.map.addOverlay(tiplabel);
        regiondata.push([]);
        item.forEach((obj) => {
          regiondata[i].push(new BMap.Point(obj[0], obj[1]));
        });
      });
      var regionpointdata = regiondata;
      console.log("00000000000", regionpointdata);
      regionpointdata.forEach((item, i) => {
        var polylines = new BMap.Polygon(item, {
          enableEditing: false,
          enableClicking: true,
          icons: [icons],
          strokeWeight: 3,
          // strokeOpacity: 0.3,
          strokeColor: "red",
          fillColor: "rgba(0, 0, 0, 0)",
          // strokeStyle: "dashed"
        });
        polylines.type = "pois";
        this.map.addOverlay(polylines);
        this.addClickHandler(polylines, regionpoint[i]);
      });
    },
    addClickHandler(marker, point) {
      console.log(marker);
      marker.addEventListener("click", (e) => {
        console.log(e);
        this.map.centerAndZoom(new BMap.Point(point[0], point[1]), 15);
        // that.openInfo(content, e);
      });
    },
    domainchange(e) {
      console.log(e);
      this.screening = e;
      this.domainName = this.allname.filter((item) => {
        return item.label.indexOf(e) > -1;
      });
    },
    constructionchange(e) {
      console.log(e);
      var datas = [];
      if (e) {
        datas = this.alldata.filter((item) => {
          return e.name === item.name;
        });
        console.log(datas);
        this.map.centerAndZoom(new BMap.Point(e.longitude, e.latitude), 16);
        if (
          datas[0][this.alltype[0]] ||
          datas[0][this.alltype[1]] ||
          datas[0][this.alltype[2]]
        ) {
          datas[0].types = "1";
        } else {
          datas[0].types = "0";
        }
        this.mapData = datas;
        this.showMarker();
      } else {
        this.map.centerAndZoom("金水区", 13);
        this.showChart();
      }
      this.construction = e.name;
    },
    filterdata() {
      console.log(this.starttime, this.endtime);
      if (!this.starttime || !this.endtime) return;
      if (this.data.length) {
        this.data = this.data.filter(
          (item) =>
            +new Date(item.supervisetime) >= +new Date(this.starttime) &&
            +new Date(item.supervisetime) <= +new Date(this.endtime)
        );
      }
      if (this.alldata.length) {
        this.alldata = this.alldata.filter(
          (item) =>
            +new Date(item.supervisetime) >= +new Date(this.starttime) &&
            +new Date(item.supervisetime) <= +new Date(this.endtime)
        );
      }
      this.showChart();
      console.log("filter", this.data, this.alldata);
    },
    timechange(e) {
      console.log(e);
      if (e && e[0] && e[1]) {
        this.starttime = getFormatDate(e[0]).substring(0, 10);
        this.endtime = getFormatDate(e[1]).substring(0, 10);
        console.log(this.starttime, this.endtime);
        this.dateValue = [this.formatting(e[0]), this.formatting(e[1])];
      } else {
        this.starttime = "";
        this.endtime = "";
      }
      this.timetype = "";
      this.getMapData();
    },
    clicktimechange(e, now) {
      console.log(this.timetype, e.target.value, now);
      if (this.timetype == now && e.target.value) {
        console.log("heere");
        // 取消
        this.timetype = "";
        this.starttime = "";
        this.endtime = "";
        this.dateValue = [];
        this.getMapData();
        // if (this.alldata && this.alldata.length) {
        //    this.filterData()
        // } else {
        //    this.getMapData();
        // }
      }
    },
    timetypechange(e) {
      console.log(e);
      const endtime = getFormatDate().substring(0, 10);
      const starttime = getFormatDateAdd(endtime, -e).substring(0, 10);
      this.timetype = e;
      this.starttime = starttime;
      this.endtime = endtime;
      this.dateValue = [this.formatting(starttime), this.formatting(endtime)];
      // this.getMapData();
      this.filterdata();
      console.log(this.data, "123234");
    },
    sectionon() {
      this.sectionflag = !this.sectionflag;
      this.propertyflag = false;
      this.areaflag = false;
      this.scurvinessflag = false;
      if (this.construction) {
        this.construction = "";
        this.map.centerAndZoom("金水区", 13);
        this.showChart();
      }
    },
    propertyon() {
      this.sectionflag = false;
      this.propertyflag = !this.propertyflag;
      this.areaflag = false;
      this.scurvinessflag = false;
      if (this.construction) {
        this.construction = "";
        this.map.centerAndZoom("金水区", 13);
        this.showChart();
      }
    },
    areaon() {
      this.sectionflag = false;
      this.propertyflag = false;
      this.areaflag = !this.areaflag;
      this.scurvinessflag = false;
      if (this.construction) {
        this.construction = "";
        this.map.centerAndZoom("金水区", 13);
        this.showChart();
      }
    },
    scurvinesson() {
      this.sectionflag = false;
      this.propertyflag = false;
      this.areaflag = false;
      this.scurvinessflag = !this.scurvinessflag;
      if (this.construction) {
        this.construction = "";
        this.map.centerAndZoom("金水区", 13);
        this.showChart();
      }
    },
    onclear() {
      this.sectionflag = false;
    },
    handleCheckedCitiesChange(e) {
      console.log(e, this.allname);
      var checkname = [];
      e.forEach((item) => {
        checkname.push(item);
      });
      // var checkdata = [];
      // var checkname = [];
      // e.forEach(item => {
      //   checkdata.push(item.index);
      //   checkname.push(item.label);
      // });
      // console.log(checkdata, checkname);
      // this.checkdata = checkdata;
      // this.checkname = checkname;
      this.checkname = checkname;
      this.checkdata = e;
    },
    propertyChange(e) {
      if (e.length) {
        this.propertydata = [];
        e[1] ? this.propertydata.push(e[1]) : this.propertydata.push(e[0]);
      } else {
        this.propertydata = [];
      }
    },
    areaChange(e) {
      if (e.length) {
        this.areadata = [];
        e[1] ? this.areadata.push(e[1]) : this.areadata.push(e[0]);
      } else {
        this.areadata = [];
      }
    },
    scurvinessChange(e) {
      if (e.length) {
        this.scurvinessdata = [];
        e[1] ? this.scurvinessdata.push(e[1]) : this.scurvinessdata.push(e[0]);
      } else {
        this.scurvinessdata = [];
      }
    },
    areaclick() {
      this.showChart();
    },
    propertyclick() {
      this.showChart();
    },
    scurvinessclick() {
      this.showChart();
    },
    regionclick() {
      console.log("00000000000", this.checkdata);
      var regionpoint = {
        丰庆路街道办事处: ["113.65685598548176", "34.83572920451538"],
        国基路街道办事处: ["113.68229599752434", "34.83922527206347"],
        北林路街道办事处: ["113.68258345528753", "34.83335890400802"],
        东风路街道办事处: ["113.66641395610792", "34.79163035095227"],
        南阳新村街道办事处: ["113.6431298772893", "34.79394257617873"],
        文化路街道办事处: ["113.67920582657001", "34.794772589787634"],
        南阳路街道办事处: ["113.65067564357311", "34.78089839795604"],
        经八路街道办事处: ["113.67906209768842", "34.777162636211116"],
        大石桥街道办事处: ["113.66598276946313", "34.78552339026521"],
        人民路街道办事处: ["113.67891836880682", "34.78368528363059"],
        杜岭街道街道办事处: ["113.66964785594384", "34.78160995226707"],
        花园路街道办事处: ["113.68876379719617", "34.78878444547025"],
        杨金路街道办事处: ["113.78743367441214", "34.86037624512576"],
        兴达路街道办事处: ["113.77040180194297", "34.86013928980414"],
        丰产街道办事处: ["113.71434753812034", "34.77514644219486"],
        未来街道办事处: ["113.71722211575228", "34.768919639751964"],
        凤凰台街道办事处: ["113.71801262460106", "34.76767422236733"],
      };
      if (this.checkdata[0]) {
        this.map.centerAndZoom(
          new BMap.Point(
            regionpoint[this.checkdata[0]][0],
            regionpoint[this.checkdata[0]][1]
          ),
          15
        );
      } else {
        this.map.centerAndZoom("金水区", 13);
      }

      this.sectionflag = false;
      this.getBoundary();
      this.showChart();
    },
    blockclick1(val) {
      console.log(val);
      if (this.type1.indexOf(val) < 0) {
        this.type1.push(val);
      } else {
        this.type1.splice(this.type1.indexOf(val), 1);
      }
      this.showChart();
      console.log(this.type1);
    },
    blockclick2(val) {
      console.log(val);
      this.type2 = val;
      this.showChart();
    },
    async getMapData() {
      var parms = {
        eid: this.userInfo.eid,
        startTime: this.starttime ? this.starttime + " 00:00:00" : "",
        endTime: this.endtime ? this.endtime + " 23:59:59" : "",
      };
      console.log(parms);
      try {
        const res = await getServerData(APIMAP.JSMAP, parms, "get");
        console.log("列表", res);
        this.data = res;
        this.alldata = res;
        this.filterdata();
        this.showChart();
      } catch (e) {
        console.log(e);
      }
    },
    async getSiteData() {
      console.log(this.userInfo);
      try {
        const res = await getServerData(
          APIMAP.GET_RESOURCE_TYPE,
          {
            gid: "1",
            mini: 1,
          },
          "get"
        );
        console.log("地址列表", res);
        this.constructiondata = res.data;
      } catch (e) {
        console.log(e);
      }
    },

    returnType(item, prop) {
      const cond = item[prop[0]] || item[prop[1]] || item[prop[2]];
      if (item[this.type2] && cond) {
        if (this.checkname.length > 0) {
          if (this.checkname.includes(item.street)) {
            item.types = "1";
          } else {
            item.types = "2";
          }
        } else {
          item.types = "1";
        }
      } else {
        item.types = "2";
      }
    },
    showChart() {
      console.log(this.checkname, this.propertydata);
      var mapData = JSON.parse(JSON.stringify(this.data));

      // 0 - 灰色 需要展示 但无特殊效果
      // 1 - 需展示有颜色工地
      // 2 - 不展示任何图标
      // 3 - 恶劣工地
      mapData.forEach((item) => {
        // 控制 整改 扣分 处罚
        const isshowtype1 =
          item[this.type1[0]] || item[this.type1[1]] || item[this.type1[2]];
        // 控制 全部 流转中 已完成
        const ishowalltype =
          item[this.alltype[0]] ||
          item[this.alltype[1]] ||
          item[this.alltype[2]];

        if (this.type2 != "all") {
          const temp = this.type1.length ? this.type1 : this.alltype;
          this.returnType(item, temp);
        } else {
          if (isshowtype1) {
            // 选了 街道办 并且 工地包含在这个当前街道办 1   2             1
            if (
              !this.checkname.length ||
              this.checkname.includes(item.street)
            ) {
              item.types = "1";
            } else {
              item.types = "2";
            }
          } else {
            if (this.checkname.length) {
              if (this.checkname.includes(item.street)) {
                item.types = "0";
              } else {
                item.types = "2";
              }
            } else {
              if (this.type1.length) {
                item.types = "2";
              } else {
                if (ishowalltype) {
                  item.types = "1";
                } else {
                  item.types = "0";
                }
              }
            }
          }
        }

        if (this.propertydata.length) {
          if (item.types == "1" || item.types == "0") {
            if (item.attribute == this.propertydata[0]) {
              isshowtype1 ? (item.types = "1") : (item.types = "0");
            } else {
              item.types = "2";
            }
          }
        }

        if (this.areadata.length) {
          if (item.types == "1" || item.types == "0") {
            if (item.area == this.areadata[0]) {
              isshowtype1 ? (item.types = "1") : (item.types = "0");
            } else {
              item.types = "2";
            }
          }
        }

        if (this.scurvinessdata.length) {
          if (item.types == "1" || item.types == "0") {
            if (this.scurvinessdata[0] == "have") {
              if (item.refuse > 0) {
                item.types = "3";
              } else {
                item.types = "2";
              }
            } else {
              if (item.refuse == 0) {
                isshowtype1 ? (item.types = "1") : (item.types = "0");
              } else {
                item.types = "2";
              }
            }
          }
        }
      });

      this.mapData = mapData;
      console.log(this.mapData);
      this.showMarker();
    },
    clearMarker() {
      this.map.getOverlays().forEach((marker) => {
        if (marker.type === "Marker") {
          this.map.removeOverlay(marker);
        }
      });
    },
    showMarker() {
      console.log(this.mapData);
      this.clearMarker();
      // const times = new Date(getFormatDate()).getTime();
      // this.mapData.forEach((item) => {
      this.mapData.forEach((item) => {
        if (item.rectify || item.deduction || item.punishment) {
          console.log("00000000000", item);
        }
        const point = new BMap.Point(item.longitude, item.latitude);
        var icon = [];
        if (item.types !== "2") {
          if (item.attribute === "一类民生") {
            icon = new BMap.Icon(Property_1, new BMap.Size(55, 63));
          } else if (item.attribute === "二类民生") {
            icon = new BMap.Icon(Property_2, new BMap.Size(55, 63));
          } else if (item.attribute === "三类民生") {
            icon = new BMap.Icon(Property_3, new BMap.Size(55, 63));
          } else if (item.attribute === "绿牌") {
            icon = new BMap.Icon(Property_4, new BMap.Size(55, 63));
          } else {
            icon = new BMap.Icon(Property_5, new BMap.Size(55, 63));
          }
          if (item.refuse > 0) {
            icon = new BMap.Icon(ScurvinessIcon, new BMap.Size(55, 63));
          }
        }
        const Marker = new BMap.Marker(point, { icon });
        if (item.attribute) {
          Marker.setZIndex(100);
        }
        if (item.refuse > 0) {
          Marker.setZIndex(200);
        }
        Marker.type = "Marker";
        if (item.types !== "2") {
          if (this.type1.length === 0) {
            this.map.addOverlay(Marker);
          } else {
            if (item.types === "1") {
              this.map.addOverlay(Marker);
            } else {
              if (this.construction) {
                this.map.addOverlay(Marker);
              }
            }
          }
        }
        Marker.addEventListener("click", () => {
          var html = `
            <div id="maptip" >
              <div class="wire" style="margin-bottom: 10px;margin-top: 10px; border-bottom: 1px solid rgba(226, 229, 236, 0.6);"></div>
              <div class="box">
                <div class="title" style="margin-bottom: 17px"><img style="position: relative;top: 2px;margin-right: 10px;" src="${RectifyIcon}" />整改事件数量</div>
                <div style="display: flex;justify-content: space-between;width: 370px;margin-left: 25px;margin-bottom: 17px">
                  <div>全部 ${
                    item.rectifycirculation + item.rectifydone
                      ? item.rectifycirculation + item.rectifydone
                      : "-"
                  }</div>
                  <div style="color: #1A7FFE">流转中 ${
                    item.rectifycirculation ? item.rectifycirculation : "-"
                  }</div>
                  <div style="color: #54D4AA">已完成 ${
                    item.rectifydone ? item.rectifydone : "-"
                  }</div>
                </div>
              </div>

              <div class="box">
                <div class="title" style="margin-bottom: 17px"><img style="position: relative;top: 2px;margin-right: 10px;" src="${DeductIcon}" />扣分事件数量</div>
                <div style="display: flex;justify-content: space-between;width: 370px;margin-left: 25px;margin-bottom: 17px">
                  <div>全部 ${
                    item.deductioncirculation + item.deductiondone
                      ? item.deductioncirculation + item.deductiondone
                      : "-"
                  }</div>
                  <div style="color: #1A7FFE">流转中 ${
                    item.deductioncirculation ? item.deductioncirculation : "-"
                  }</div>
                  <div style="color: #54D4AA">已完成 ${
                    item.deductiondone ? item.deductiondone : "-"
                  }</div>
                </div>
              </div>

              <div class="box">
                <div class="title" style="margin-bottom: 17px"><img style="position: relative;top: 2px;margin-right: 10px;" src="${PunishIcon}" />处罚事件数量</div>
                <div style="display: flex;justify-content: space-between;width: 370px;margin-left: 25px;margin-bottom: 24px">
                  <div>全部 ${
                    item.punishmentdone + item.punishmentcirculation
                      ? item.punishmentdone + item.punishmentcirculation
                      : "-"
                  }</div>
                  <div style="color: #1A7FFE">流转中 ${
                    item.punishmentcirculation
                      ? item.punishmentcirculation
                      : "-"
                  }</div>
                  <div style="color: #54D4AA">已完成 ${
                    item.punishmentdone ? item.punishmentdone : "-"
                  }</div>
                </div>
              </div>

              <div style="font-size: 14px;color: #99a9ba;">
                更新时间： ${item.lasttime ? item.lasttime : "-"}
              </div>
            </div>
            `;

          var title = `
            <i class="el-icon-location" style="color: #1A7FFE;margin-right:10px;font-size: 18px"></i><span style="font-size: 18px">地点：${item.name}</span>
            `;
          var opts = {
            width: 450, // 信息窗口宽度
            height: 310, // 信息窗口高度
            title: title, // 信息窗口标题
          };
          var infoWindow = new BMap.InfoWindow(html, opts); // 创建信息窗口对象
          this.map.openInfoWindow(infoWindow, point); //开启信息窗口
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.map {
  width: 100%;
  height: 100%;
  position: relative;
  .listbtnbox {
    position: absolute;
    top: 108px;
    left: 20px;
    width: 430px;
    display: flex;
    justify-content: space-between;
    .listbtn {
      background: white;
      text-align: center;
      line-height: 40px;
      color: #009157;
      font-weight: 500;
      letter-spacing: 1px;
      width: 100px;
      height: 40px;
      border-radius: 6px;
      box-shadow: 0px 4px 12px 0px rgba(57, 117, 186, 0.12);
      cursor: pointer;
    }
  }

  .constructionsearch {
    position: absolute;
    top: 50px;
    left: 20px;
  }
  .sectionbox {
    position: absolute;
    top: 160px;
    left: 20px;
    width: 388px;
    height: 473px;
    background: white;
    border-radius: 6px;
    box-shadow: 0px 4px 12px 0px rgba(57, 117, 186, 0.12);
    padding: 16px 12px;
    overflow: hidden;
    .title {
      font-size: 16px;
      color: #576071;
      letter-spacing: 1px;
    }
    .close {
      position: absolute;
      right: 12px;
      top: 16px;
    }
    .wire {
      margin-top: 10px;
      border-bottom: 1px solid rgba(226, 229, 236, 0.6);
    }
    .search {
      margin-top: 10px;
    }
    .checks {
      background: #f5f6fd;
      margin-top: 10px;
      height: 320px;
      overflow: auto;
      .checklist {
        padding: 11px 13px;
        border-bottom: 1px dashed #e2e5ec;
      }
    }
    .regionbtn {
      margin-top: 20px;
      width: 100%;
      text-align: center;
    }
  }
  .timeblock {
    position: absolute;
    top: 50px;
    right: 45px;
  }
  .mapblock {
    width: 73px;
    // height: 385px;
    position: absolute;
    right: 45px;
    bottom: 85px;
    .block1 {
      height: 157px;
    }
    .block3 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #99a9ba;
      line-height: 36px;
      letter-spacing: 2px;
      width: 73px;
      height: 36px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 12px 0px rgba(57, 117, 186, 0.12);
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .mb16 {
      margin-bottom: 16px;
    }
    .mb16 span:nth-child(1) {
      margin-right: 4px;
    }
    .block4 {
      width: 49px;
      // height: 151px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 12px 0px rgba(57, 117, 186, 0.12);
      border-radius: 6px;
      padding: 0 12px;
      margin-top: 74px;
    }
    .item {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 169, 186, 1);
      line-height: 37px;
      letter-spacing: 1px;
      text-align: center;
      cursor: pointer;
    }
    .bb {
      border-bottom: 1px dashed #e7e8ee;
    }
    .addcolor {
      color: #009157;
    }
  }
  .maptip {
    background: #009157;
    .box {
      img {
        display: inline-block;
        position: relative;
        top: 1px;
      }
      // .title {
      // }
    }
  }
  .prompt {
    position: absolute;
    right: 45px;
    bottom: 20px;
    width: 510px;
    height: 50px;
    border-radius: 6px;
    background: #fff;
    font-size: 12px;
    color: #99a9ba;
    font-weight: 500;
    padding-left: 14px;
    display: flex;
    align-items: center;
    img {
      width: 30px;
      height: 38px;
      margin-right: 6px;
      margin-top: 5px;
    }
    span {
      margin-right: 6px;
    }
  }
}
</style>